import React from 'react';
import useDate, { useRelativeDate } from '~/react-hooks/use-date';
import { GreetResultWithOccurredAt } from './UserHistory';
import { ProfileEvent } from '~/types/models';

interface UserHistoryItemProps {
  history: GreetResultWithOccurredAt | ProfileEvent;
}

const HistoryItem = ({ history }: UserHistoryItemProps) => {
  const formatDate = useDate(history.occurred_at);

  if (Object.hasOwnProperty.call(history, 'greet')) {
    const greet = (history as GreetResultWithOccurredAt).greet;

    return (
      <a
        href={(history as GreetResultWithOccurredAt).results_url}
        target='_blank'
        className='border border-solid v2-border-neutral-300 w-full rounded p-2.5 flex gap-2.5 max-w-xs hover:v2-bg-yellow-50'
        rel='noreferrer'
      >
        <img className='rounded' src={greet.thumb_url} height={50} width={50} />
        <div className='text-neutral-900 font-bold break-words self-center'>
          By {greet.assignee.first_name}
        </div>
        <div className='ml-2 flex justify-end grow text-xs text-neutral-500'>
          {formatDate.local.toFormat('MM/dd/yyyy')}
        </div>
      </a>
    );
  }

  return (
    <div className='v2-text-neutral-900 max-w-xs'>
      {(history as ProfileEvent).message}
    </div>
  );
};

export default function UserHistoryItem({ history }: UserHistoryItemProps) {
  const date = useRelativeDate(history.occurred_at, 'long');

  return (
    <div className='flex flex-wrap'>
      <div className='uppercase mt-1 text-xs v2-text-neutral-500 w-[130px] font-bold'>
        {date}
      </div>
      <div className='min-w-[100px]'>
        <HistoryItem history={history} />
      </div>
    </div>
  );
}
